<template>
  <v-dialog
    :value="showDialog"
    @input="close()"
    width="600"
    @keydown.esc="close()"
  >
    <v-card id="pendingApproval" text>
      <v-app-bar dark text tabs color="primary">
        <v-btn icon dark @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ resx.labels.requestAccess }}</v-toolbar-title>
      </v-app-bar>
      <v-card-text>
        <v-list two-line>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title v-if="value">{{
                value.data.requestAccess.contractorCompany.contractor.name
              }}</v-list-item-title>
              <v-list-item-subtitle>{{
                resx.labels.name
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title v-if="value">{{
                value.data.requestAccess.requestDate | date
              }}</v-list-item-title>
              <v-list-item-subtitle>{{
                resx.labels.startDateOfVisit
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title v-if="value">{{
                value.requestedBy.fullname
              }}</v-list-item-title>
              <v-list-item-subtitle>{{
                resx.labels.requestedBy
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-divider></v-divider>
         <!-- TABS -->
        <v-tabs
        :icons-and-text="$vuetify.breakpoint.smAndUp"
        centered
        grow
        >
        <v-tabs-slider color="accent"></v-tabs-slider>
        <v-tab href="#obligations">
          <span v-if="$vuetify.breakpoint.smAndUp">{{
            resx.labels.obligations
          }}</span>
          <v-icon>description</v-icon>
          <v-badge
            overlap
            :color="countInvalidObligations > 0 ? 'error' : 'green'"
            v-if="countInvalidObligations >= 0"
          >
            <span slot="badge">{{
              countInvalidObligations
            }}</span>
          </v-badge>
        </v-tab>
        <v-tab href="#employees">
          <span v-if="$vuetify.breakpoint.smAndUp">{{
            resx.labels.employees
          }}</span>
          <v-icon>people</v-icon>
          <v-badge
            overlap
            :color="invalidEmployees.length > 0 ? 'error' : 'green'"
            v-if="countInvalidObligations >= 0"
          >
            <span slot="badge">{{
              invalidEmployees.length
            }}</span>
          </v-badge>
        </v-tab>
        <v-tab href="#vehicles">
          <span v-if="$vuetify.breakpoint.smAndUp">{{
            resx.labels.vehicles
          }}</span>
          <v-icon>commute</v-icon>
          <v-badge
            overlap
            :color="invalidVehicles.length ? 'error' : 'green'"
            v-if="countInvalidObligations >= 0"
          >
            <span slot="badge">{{
              invalidVehicles.length}}
            </span>
          </v-badge>
        <v-divider></v-divider>
        </v-tab>
        <!-- TABS -->
        <v-tab-item value="obligations">
          <request-access-obligations-details
            :obligations="getInvalidObligations"
            @viewComment="viewComment($event)"
            :invalidEmployeesPPIList="this.invalidEmployeesPPIList"
          ></request-access-obligations-details>
        </v-tab-item>
        <v-tab-item value="employees">
          <request-access-employees-details
            :invalidEmployees="this.invalidEmployees"
            :delayedEmployeeObligations="delayedEmployeeObligations"
            :invalidEmployeesPPIList="this.invalidEmployeesPPIList"
          ></request-access-employees-details>
        </v-tab-item>
        <v-tab-item value="vehicles">
          <request-access-vehicles-details
            :invalidVehicles="this.invalidVehicles"
            :delayedVehicleObligations="delayedVehicleObligations"
          ></request-access-vehicles-details>
        </v-tab-item>
        </v-tabs>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" @click="close()">
          {{ resx.labels.close }}
        </v-btn>
        <v-btn color="error" @click="save('reject')">
          {{ resx.labels.reject }}
        </v-btn>
        <v-btn color="success" @click="save('approve')">
          {{ resx.labels.approve }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
"use strict";

import { EventBus } from "@/bus";
import contractorCompanyService from "@/services/ContractorCompanyService";
import requestAccessObligationsDetails from "./request-access-obligations-details.view.vue";
import requestAccessVehiclesDetails from "./request-access-vehicles-details.view.vue";
import requestAccessEmployeesDetails from "./request-access-employees-details.view.vue";
import constants from "@/utils/constants";

export default {
  name: "showRequestAccess",
  async mounted() {
  },
  data() {
    return {
      showDialog: false,
      comment: {
        show: false,
        title: null,
        value: null
      },
      contractorCompany: null,
      delayedEmployeeObligations: [],
      delayedVehicleObligations: [],
      employeesIsAuthorized: true,
      employeesPersonalProtectionItemsVerified: true,
      employeesPersonalProtectionItemsVerify: false,
      invalidEmployees: [],
      invalidVehicles: [],
      obligations: [],
      personalProtectionItems: { verify: false },
      employeePPIList: {},
      invalidEmployeesPPIList: {},
      empresaPPI: {},
      companyPPIToVerify: {},
      visitEmployeesPPI: {},
      vehiclesIsAuthorized: true,
      visit: null
    };
  },
    components: {
    requestAccessObligationsDetails,
    requestAccessVehiclesDetails,
    requestAccessEmployeesDetails
    },
  computed: {
    isReady() {
      return (
        !this.isLoading &&
        this.countInvalidObligations >= 0 &&
        this.invalidVehicles.length >= 0 &&
        this.invalidEmployees.length >= 0
      );
    },
    getInvalidObligations() {
      return this.contractorObligations.filter(
        o =>
          o.type == this.$store.state.constants.OBLIGATIONS.TYPES.OBLIGATION &&
          contractorCompanyService.isInvalidObligation(o)
      );
    },
    countInvalidObligations() {
      return this.contractorObligations.filter(
        o =>
          o.type == this.$store.state.constants.OBLIGATIONS.TYPES.OBLIGATION &&
          contractorCompanyService.isInvalidObligation(o)
      ).length;
    },
    countInvalidVehicles() {
      return this.vehicleObligations.filter(
        o =>
          o.type ==
            this.$store.state.constants.OBLIGATIONS.TYPES.VEHICLE_OBLIGATION &&
          contractorCompanyService.isInvalidObligation(o)
      ).length;
    },
    isSuitable() {
      return this.contractorCompany.hasDelayed == false;
    },
    contractorObligations() {
      return this.obligations.filter(
        o =>
          o.type == this.$store.state.constants.OBLIGATIONS.TYPES.OBLIGATION &&
          o.status != this.$store.state.constants.OBLIGATIONS.STATUS.EXCLUDED
      );
    },
    employeeObligations() {
      return this.obligations.filter(
        o =>
          o.type ==
            this.$store.state.constants.OBLIGATIONS.TYPES.EMPLOYEES_OBLIGATION &&
          o.status != this.$store.state.constants.OBLIGATIONS.STATUS.EXCLUDED
      );
    },
    vehicleObligations() {
      return this.obligations.filter(
        o =>
          o.type ==
            this.$store.state.constants.OBLIGATIONS.TYPES.VEHICLE_OBLIGATION &&
          o.status != this.$store.state.constants.OBLIGATIONS.STATUS.EXCLUDED
      );
    },
    initials() {
      const parts =
        this.contractorCompany.contractor &&
        this.contractorCompany.contractor.name.split(" ");
      let initials = "";
      parts.forEach(part => {
        initials += part[0];
      });
      return initials.substring(0, 3);
    },
    isRequest() {
      let visitor = this.value.data.requestAccess.contractorVisit.employees;
      return visitor.name;
    }
  },
  methods: {
    close() {
      this.showDialog = false;
      this.$emit("close");
    },
    async save(action) {
      const result = await contractorCompanyService.approveRequestAccess(
        this.value.data.requestAccess.contractorCompany._id,
        this.value.data.requestAccess._id,
        action,
        this.value._id
      );
      this.$store.commit("substractRequestAccess", this.value._id);
      this.showDialog = false;
      this.$emit("close");
      // TODO: Check if event below is useful
      EventBus.$emit("pendingRequestAccess", { result });
    },
    viewComment(data) {
      this.comment = Object.assign({}, { show: true }, data);
    },
    goBack() {
      clearTimeout(this.goBackTimeout);
      this.$router.back();
    },
    filterInvalidEmployees(requestAccessEmployees) {
      let invalidEmployeesList = [];
      this.delayedEmployeeObligations = this.employeeObligations.filter(o => {
        let isRequestAccessEmployeeObligation = false;
        requestAccessEmployees.forEach(requestAccessEmployee => {
          // check each contractor company obligation and keep only
          // obligations that belong to this request access employees
          if (requestAccessEmployee._id == o.referenceId) {
            isRequestAccessEmployeeObligation = true;
          }
        })
        // ignore obligations that are not part of request access employees
        if (!isRequestAccessEmployeeObligation) return false;
        const isInvalidObligation = 
          contractorCompanyService.isInvalidObligation(o);
        if (isInvalidObligation) {
          // if invalid obligation mark employee as invalid
          invalidEmployeesList.push(String(o.referenceId));
        }
        return isInvalidObligation;
      });
      let visitEmployeesPPI = JSON.parse(JSON.stringify(this.visitEmployeesPPI))
      let companyPPIToVerify = JSON.parse(JSON.stringify(this.companyPPIToVerify))
      let invalidEmployeesPPIList = {};
      this.invalidEmployeesPPIList = invalidEmployeesPPIList
      Object.entries(visitEmployeesPPI).forEach(([employeeId, employeePPI]) => {
        if (!employeePPI.verifies) {
          invalidEmployeesPPIList[employeeId] = [];
          Object.entries(companyPPIToVerify).forEach(([PPI]) => {
            if (employeePPI[PPI] != companyPPIToVerify[PPI] &&
              constants.PERSONAL_PROTECTION_ITEMS.indexOf(PPI) != -1) {
                invalidEmployeesPPIList[employeeId].push(String(PPI));
                invalidEmployeesList.push(String(employeeId));
            }
          })
        }
      })
      return requestAccessEmployees.filter(e => {
        let isInvalidEmployee = false;
        invalidEmployeesList.forEach(invalidEmployee => {
          if (e.id == invalidEmployee) isInvalidEmployee = true;
        })
        return isInvalidEmployee;
      });
    },
    filterInvalidVehicles(requestAccessVehicles) {
      let invalidVehiclesList = [];
      this.delayedVehicleObligations = this.vehicleObligations.filter(o => {
        let isRequestAccessVehicleObligation = false;
        requestAccessVehicles.forEach(requestAccessVehicle => {
          if (requestAccessVehicle._id == o.referenceId) {
            isRequestAccessVehicleObligation = true;
          }
        })
        if (!isRequestAccessVehicleObligation) return false;
        const isInvalidObligation =
          contractorCompanyService.isInvalidObligation(o);
        if (isInvalidObligation) {
          invalidVehiclesList.push(String(o.referenceId));
        }
        return isInvalidObligation;
      });
      return requestAccessVehicles.filter(v => {
        let isInvalidVehicle = false;
        invalidVehiclesList.forEach(invalidVehicle => {
          if (v._id == invalidVehicle) isInvalidVehicle = true;
        })
        return isInvalidVehicle;
      });
    },
  },
  props: {
    value: { type: Object },
  },
  watch: {
    value: {
      handler: function(val) {
        this.showDialog = val != null;
        if (this.showDialog && typeof val.data.requestAccess != "undefined") {
          this.contractorCompany = val.data.requestAccess.contractorCompany;
          this.obligations = this.contractorCompany.obligations;
          this.companyPPIToVerify = val.data.requestAccess.contractorCompany.personalProtectionItems;
          this.employeesPersonalProtectionItemsVerified = true;
          this.employeesPersonalProtectionItemsVerify = this.personalProtectionItems.verify;
          this.visitEmployeesPPI = val.data.requestAccess.employeesPPI;
          let requestAccessEmployees = this.contractorCompany.employees.filter(employee => {
            for (const v of val.data.requestAccess.contractorVisit.employees) {
              if (v == employee.id) {
                return true;
              }
            }
          })
          this.invalidEmployees = this.filterInvalidEmployees(requestAccessEmployees);
          let requestAccessVehicles = this.contractorCompany.vehicles.filter(vehicle => {
            for (const v of val.data.requestAccess.contractorVisit.vehicles) {
              if (v == vehicle._id) {
                return true;
              }
            }
          })
          this.invalidVehicles = this.filterInvalidVehicles(requestAccessVehicles);
        };
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss">
#pendingApproval {
  .v-tabs__items {
    min-height: 304px;
  }
}

#admin-contractor-profile {
  .v-list-group--sub-group .v-list-group__header .v-tab {
    padding-left: 0px;
  }
  .v-card__text .v-item-group #employees .col {
    padding-right: 0px;
    padding-left: 0px;
    padding-top: 0px;
  }

  .v-list-group__items .v-list-item {
    padding-right: 16px;
    margin-right: 17px;
  }

  .v-list-group__header__prepend-icon {
    align: center;
  }
  .text-xs-center {
    margin-right: 40px;
  }
  .v-tab {
    min-width: 0px;
  }

  .v-list-item {
    padding-left: 22px;
    .theme--light {
      padding-left: 4px;
      .arrow_drop_down {
        padding-top: 40px;
      }
    }
  }

  .v-list-item__content {
    padding-left: 15px;
  }

  .display-1 {
    word-break: break-word;
  }
}
</style>
